import { render, staticRenderFns } from "./environment-float.vue?vue&type=template&id=035db0ac&scoped=true"
import script from "./environment-float.vue?vue&type=script&setup=true&lang=js"
export * from "./environment-float.vue?vue&type=script&setup=true&lang=js"
import style0 from "./environment-float.vue?vue&type=style&index=0&id=035db0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035db0ac",
  null
  
)

export default component.exports